import { Upload, message } from 'ant-design-vue';
import { computed, ref, unref } from 'vue';
import useConfigProvider from '../../config-provider/src/useConfigProvider';
import type { EmbedFileInfo, FileItem, IUpload } from '../types';
import { UploadResultStatus } from '../types';

export function checkFileType(file: File, accepts: string) {
  if (accepts === '*') return true;
  const reg = new RegExp(`${accepts?.split(',').join('|')}$`, 'i');
  return reg.test(file.name);
}

/*
 * @Description: ^_^
 * @Author: sharebravery
 * @Date: 2022-04-28 17:29:33
 * @LastEditors: sharebravery
 * @LastEditTime: 2022-04-29 16:22:31
 */

export function useUpload(props: IUpload, { emit, attrs }: any) {
  const fileListRef = ref<FileItem[]>([]);
  const { injectConfig } = useConfigProvider();

  const getBindValue = computed(() => ({ ...injectConfig<IUpload>('upload', props)?.value, ...attrs }));

  /**
   *开始上传
   *
   * @param {*} file
   */
  const uploadFile = async (item: FileItem) => {
    if (!unref(getBindValue).api) {
      throw new Error('api不能为空');
    }
    item.status = UploadResultStatus.UPLOADING;

    const formData = new FormData();

    formData.append('file', item.file);

    const data = await unref(getBindValue).api(unref(getBindValue).params, formData);

    item.status = UploadResultStatus.SUCCESS;
    return data;
  };

  /**
   *点击开始上传
   *
   * @return {*}
   */
  async function startUpload() {
    if (fileListRef.value.length > unref(getBindValue).maxCount) {
      message.warning('文件数量超出限制');
      return;
    }
    try {
      // 只上传不是成功状态的
      const uploadFileList = fileListRef.value.filter(item => item.status !== UploadResultStatus.SUCCESS) || [];
      let data: EmbedFileInfo[] = [];
      if (getBindValue.value.multiple) {
        // multiple多选返回2维数组
        data = await Promise.all(
          uploadFileList.map(item => {
            return uploadFile(item);
          })
        );
      } else {
        // 返回1维数组
        data = await uploadFile(uploadFileList[0]);
      }
      // const data = await Promise.all(
      //   uploadFileList.map((item) => {
      //     return uploadFile(item);
      //   })
      // );
      emit('fileResult', data);
    } catch (e: any) {
      message.warning(e.message);
      throw e;
    }
  }

  /**
   *上传前校验
   *
   * @param {File} file
   * @return {*}
   */
  async function beforeUpload(file: File) {
    const { size, name } = file;

    // 设置最大值，则判断
    if (unref(getBindValue).maxSize && file.size / 1024 / 1024 >= unref(getBindValue).maxSize) {
      message.warning('文件大小超出限制');
      return Upload.LIST_IGNORE;
    }
    // 设置类型,则判断
    if (!checkFileType(file, unref(getBindValue).accept)) {
      message.warning(`请上传${unref(getBindValue).accept}格式的文件`);
      return Upload.LIST_IGNORE;
    }

    const commonItem: FileItem = {
      uid: file?.uid,
      file,
      size,
      name,
      type: name.split('.').pop(),
      percent: 0,
    };

    fileListRef.value.push(commonItem);

    emit('completeCheckType', file); // 完成文件校验

    // 立即上传
    if (unref(getBindValue).uploadNow === true) {
      startUpload();
    }

    return false;
  }

  return {
    fileListRef,
    beforeUpload,
    startUpload,
    getBindValue,
  };
}
